/**
 * Ko plugin to create trackableObserver
 */
define('customPlugins/atnCheckboxWidgets',['knockout', 'lodash', 'jquery'],
    function(ko, _, $) {
        'use strict';

        ko.bindingHandlers.atnTristateCheckbox = {
            init: initTristateCheckbox,
            update: updateTristateCheckbox
        };

        ko.bindingHandlers.atnGridCheckbox = {
            init: initGridCheckbox,
            update: updateGridCheckbox
        };

        function initTristateCheckbox(element, valueAccessor, allBindings, viewModel, bindingContext) {
            $(element).on('click', function(e) {
                var value = valueAccessor();
                _.defer(function() {
                    value($(element).prop('checked') ? 2 : 0);
                });
                e.stopPropagation();
            });
        }

        function updateTristateCheckbox(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var value = valueAccessor(),
                el = $(element);
            setCheckboxState(el, value());
        }

        function initGridCheckbox(element, valueAccessor, allBindings, viewModel, bindingContext) {

            //  when grid created event has fired
            $(element).on('grid-created', function() {
                //  searching for title checkbox
                var titleCheckbox =
                    $(element).find('.k-grid-header thead>tr>th>input[type=checkbox]');


                //  binding event on that checkbox
                titleCheckbox.on('click', function(e) {
                    var value = valueAccessor(),
                        titleCheckbox = $(this),
                        columnCheckbox =
                        $(element).find('.k-grid-content tbody>tr>td>input[type=checkbox]');
                    _.defer(function() {
                        var idList = [];
                        if (titleCheckbox.prop('checked')) {
                            columnCheckbox.each(function() {
                                idList.push($(this).val());
                            });
                        }
                        value(idList);
                    });
                    e.stopPropagation();
                });
            });
        }

        function updateGridCheckbox(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var value = valueAccessor(),
                state = 0,
                titleCheckbox =
                $(element).find('.k-grid-header thead>tr>th>input[type=checkbox]'),
                columnCheckbox =
                $(element).find('.k-grid-content tbody>tr>td>input[type=checkbox]');
            if (value().length) {
                state = 1 + (value().length === columnCheckbox.length);
            }
            setCheckboxState(titleCheckbox, state);
            //if checkboxstate observable is present in viewmodel then-
            //update the state of checkbox in that observable.
            if (viewModel.checkBoxState) {
                viewModel.checkBoxState(state);
            }
        }

        function setCheckboxState(jqCheckbox, state) {
            switch (state) {
                //  checked
                case 2:
                    jqCheckbox.prop('indeterminate', false);
                    jqCheckbox.prop('checked', true);
                    break;
                    // indeterminate
                case 1:
                    jqCheckbox.prop('indeterminate', true);
                    jqCheckbox.prop('checked', false);
                    break;
                    // unchecked
                default:
                    jqCheckbox.prop('indeterminate', false);
                    jqCheckbox.prop('checked', false);
            }
        }
    });
